import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

export const ProtectedRoute = ({ children }) => {
  const { user, checking } = useAuth();
  const location = useLocation();
  if (checking) {
    return <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-checking"><Loader2 className="w-8 h-8 animate-spin text-[#0F8B5C]" /></div>;
  }
  if (!user) return <Navigate to={`/signin?next=${encodeURIComponent(location.pathname)}`} replace />;
  return children;
};
